import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions, CategoryActions } from 'actions';
import { CategoryStore, AuthStore, StoreOverviewStore } from 'stores';
import StoreBar from 'components/StoreBar';
import StoreLayout from 'components/Store/StoreLayout';
import StoreLayoutOverview from 'components/Store/Editor/StoreLayoutOverview';
import StoreModuleMenu from 'components/Store/Editor/StoreModuleMenu';
import Loader from 'components/Material/Loader';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import { mixin, RefluxMixin } from 'Util';
import { history } from 'helpers';
import Helmet from 'react-helmet';
import {
  getVisibleStoreItems,
  getSelectedSection,
  getSelectedModule,
  getLayout,
  getStoreItems
} from 'selectors/store';

export default class StoreContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  componentDidMount() {
    const { params } = this.props;
    const { store, username } = this.state;
    StoreOverviewActions.read(params.store || store || username);
    // CategoryActions.initCategories();
    StoreOverviewActions.clearSelected();
  }

  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => {
      const items = getVisibleStoreItems(state);
      const storeItems = getStoreItems(state);
      return {
        ownerName: state.owner.name,
        userLocale: state.owner.locale,
        store: state.name,
        mode: state.mode,
        storeItems,
        items,
        coverUrl: state.presentation.coverUrl,
        name: state.presentation.text,
        searchText: state.filter.searchText,
        moduleMenu: state.moduleMenu,
        dialogMode: state.dialogMode,
        selectedModule: getSelectedModule(state),
        selectedSection: getSelectedSection(state),
        canIEdit: state.canIEdit,
        layout: getLayout(state),
        themeColor: state.theme.color,
        logoUrl: state.theme.logoUrl,
        canUndo: state.layoutHistory.length > 0,
        loading: state.loading && items.length < 1
      };
    });
    this.listenToStoreWithMapper(CategoryStore, state => {
      return {
        categories: state.list
      };
    });
    this.listenToStoreWithMapper(AuthStore, state => {
      return {
        username: state.username,
        features: state.features
      };
    });
  }

  getStoreItem = storeItem => {
    const { type, slug } = storeItem;
    const { store } = this.state;
    if (type === 1) {
      history.push(`/store/${store}/${slug}`);
    } else {
      history.push(`/store/package/${store}/${slug}`);
    }
  };

  render() {
    const {
      store,
      canUndo,
      ownerName,
      userLocale,
      selectedSection,
      selectedModule,
      layout,
      themeColor,
      logoUrl,
      items,
      storeItems,
      loading,
      canIEdit,
      moduleMenu,
      categories,
      searchText,
      features,
      name,
      coverUrl,
      mode
    } = this.state;
    if (loading) {
      return <Loader />;
    }
    const toolbar = (
      <StoreBar
        mode={mode}
        canIEdit={canIEdit && features && features.enterpriseStore}
        logo={logoUrl}
        title={this.context.getIntlMessage('menu.Store')}
      />
    );
    return (
      <ScrollableContainer header={toolbar}>
        <StoreLayout
          canIEdit={canIEdit}
          selectedModule={selectedModule}
          selectedSection={selectedSection}
          ownerName={ownerName}
          userLocale={userLocale}
          mode={mode}
          store={store}
          storeName={store}
          themeColor={themeColor}
          items={items}
          searchText={searchText}
          storeItems={storeItems}
          layout={layout}
          history={history}
        />
        <StoreLayoutOverview
          canIEdit={canIEdit}
          categories={categories}
          canUndo={canUndo}
          width={selectedModule ? 780 : 390}
          layout={layout}
          selectedSection={selectedSection}
          selectedModule={selectedModule}
          open={mode === 'editor'}
        />
        <StoreModuleMenu open={moduleMenu} />
        <Helmet
          meta={[
            { name: 'twitter:card', content: "summary_large_image" },
            { name: 'twitter:image', content: coverUrl || 'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png' },
            { name: 'og:url', content: window.location.href },
            { name: 'og:title', content: ownerName },
            { name: 'og:image', content: coverUrl || 'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png' },
          ]}
          title={ownerName}
        />
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/StoreContainer.js